import PopupController from './popup/popup.controller';

const popupTemplate = require('./popup/popup.html');

/** @ngInject */
export default function editNavbarDirectiveConfig(DialogService) {
    function link($scope, $element) {
        function showDialog(event) {
            event.preventDefault();

            DialogService.show({
                controller: PopupController,
                controllerAs: 'ctrl',
                template: popupTemplate,
                parent: document.body,
                targetEvent: event,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    onDone: $scope.dtEditNavbar || null
                }
            });
        }

        $element.on('click', showDialog);

        $element.on('$destroy', () => {
            $element.off('click', showDialog);
        });
    }

    return {
        restrict: 'A',
        scope: {
            dtEditNavbar: '&'
        },
        link
    };
}



// WEBPACK FOOTER //
// ./app/common/edit-navbar/edit-navbar.directive.js